/**
 * @module helpers/sendEvent
 * Pushes data to cX
 */

import log from './logger';

const sendEvent = (type, data) => {
  DMP.forEach(dmp => {
    if (dmp.push) {
      window.cX = window.cX || {};
      window.cX.callQueue = window.cX.callQueue || [];
      window.cX.callQueue.push([
        'sendEvent',
        type,
        data,
        {
          origin: `${dmp.prefix}-${dmp.push.origin}`,
          persistedQueryId: dmp.push.queryid,
        },
      ]);
      log(`push ${type} to ${dmp.prefix}`);
    }
  });
};

export default sendEvent;
